let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("kqU5B")).then(() => parcelRequire('bJYvw'));